// Fonte: UManutContas.pas — Ds_Contas_Clientes → tabela Contas_Clientes
// Validação: Banco/Agência duplicado requer permissão 488
// Log: Grava log tipo CBF (Contas Bancárias Fornecedor)
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Form, Modal, Spinner, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  listarContasBancariasConta,
  inserirContaBancariaConta,
  atualizarContaBancariaConta,
  excluirContaBancariaConta,
  listarBancosLista,
} from '~/Services/Service';
import aplicarMascara from '../components/mascaras';

// Fonte: UManutContas.dfm, DbcOperacao (TRxDBComboBox) — códigos de operação CEF
var OPERACAO_OPTS = [
  { value: null, label: '(Nenhum)' },
  { value: 1, label: '001' },
  { value: 2, label: '002' },
  { value: 3, label: '003' },
  { value: 6, label: '006' },
  { value: 7, label: '007' },
  { value: 13, label: '013' },
  { value: 22, label: '022' },
  { value: 23, label: '023' },
  { value: 28, label: '028' },
  { value: 37, label: '037' },
  { value: 43, label: '043' },
  { value: 1288, label: '1288' },
  { value: 1292, label: '1292' },
  { value: 3701, label: '3701' },
];

// Fonte: UManutContas.dfm, cbTipoChave (TComboBox) — tipos de chave PIX
var TIPO_CHAVE_PIX_OPTS = [
  { value: '', label: 'Nenhum' },
  { value: '1', label: 'CPF/CNPJ' },
  { value: '2', label: 'Telefone (DDD + Número)' },
  { value: '3', label: 'E-mail' },
  { value: '4', label: 'Aleatório' },
];

var VAZIO = {
  tipo: '',
  codigo_banco: '',
  nome_banco: '',
  agencia: '',
  digito_agencia: '',
  numero_conta: '',
  digito_conta: '',
  tipo_conta: null,
  nome_agencia: '',
  titular_conta: '',
  cpf: '',
  finalidade: '',
  tipo_chave_pix: '',
  chave_pix: '',
  // Fonte: UManutContas.pas:9567-9571 — CheckBox1 "NSGED" grava 'N' ou NULL.
  tipo_cef: false,
};

var TabContasBancarias = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var [lista, setLista] = useState([]);
  var [bancosLista, setBancosLista] = useState([]);
  var [loading, setLoading] = useState(false);
  var [showModal, setShowModal] = useState(false);
  var [editando, setEditando] = useState(null);
  var [form, setForm] = useState(VAZIO);
  var [salvando, setSalvando] = useState(false);
  var [showExcluir, setShowExcluir] = useState(null);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    listarContasBancariasConta(ge, codigo)
      .then(function(resp) {
        setLista(Array.isArray(resp) ? resp : []);
      })
      .catch(function() { toast.error('Erro ao carregar contas bancárias'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() {
    carregar();
    listarBancosLista()
      .then(function(resp) {
        var data = Array.isArray(resp) ? resp : [];
        setBancosLista(data.map(function(b) {
          return { value: b.codigo, label: b.codigo + ' - ' + (b.descricao !== null && b.descricao !== undefined ? b.descricao : '') };
        }));
      })
      .catch(function() {});
  }, [carregar]);

  var handleNovo = function() {
    setEditando(null);
    setForm({ ...VAZIO });
    setShowModal(true);
  };

  var handleEditar = function(item) {
    setEditando(item);
    setForm({
      tipo: item.tipo !== null && item.tipo !== undefined ? item.tipo : '',
      codigo_banco: item.codigo_banco !== null && item.codigo_banco !== undefined ? item.codigo_banco : '',
      nome_banco: item.nome_banco !== null && item.nome_banco !== undefined ? item.nome_banco : '',
      agencia: item.agencia !== null && item.agencia !== undefined ? item.agencia : '',
      digito_agencia: item.digito_agencia !== null && item.digito_agencia !== undefined ? item.digito_agencia : '',
      numero_conta: item.numero_conta !== null && item.numero_conta !== undefined ? item.numero_conta : '',
      digito_conta: item.digito_conta !== null && item.digito_conta !== undefined ? item.digito_conta : '',
      tipo_conta: item.tipo_conta !== null && item.tipo_conta !== undefined ? item.tipo_conta : null,
      nome_agencia: item.nome_agencia !== null && item.nome_agencia !== undefined ? item.nome_agencia : '',
      titular_conta: item.titular_conta !== null && item.titular_conta !== undefined ? item.titular_conta : '',
      // Backend retorna decimal (number) — normaliza para string para evitar .replace em number.
      cpf: item.cpf !== null && item.cpf !== undefined ? String(item.cpf) : '',
      finalidade: item.finalidade !== null && item.finalidade !== undefined ? item.finalidade : '',
      tipo_chave_pix: item.tipo_chave_pix !== null && item.tipo_chave_pix !== undefined ? item.tipo_chave_pix : '',
      chave_pix: item.chave_pix !== null && item.chave_pix !== undefined ? item.chave_pix : '',
      tipo_cef: item.tipo_cef === 'N',
    });
    setShowModal(true);
  };

  var handleSalvar = function() {
    setSalvando(true);
    // DW-0963: titular pode ser PJ (label "CPF/CNPJ", maxLength 18, log CBF/UManutContas.pas) →
    // normaliza preservando letras (uppercase), sem Number()/\D-strip que apagariam A-Z (NaN).
    const cpfLimpo = form.cpf !== null && form.cpf !== undefined && form.cpf !== ''
      ? String(form.cpf).toUpperCase().replace(/[^A-Z0-9]/g, '')
      : '';
    var payload = {
      tipo: form.tipo || null,
      codigo_banco: form.codigo_banco !== '' ? Number(form.codigo_banco) : null,
      nome_banco: form.nome_banco || null,
      agencia: form.agencia !== '' ? Number(form.agencia) : null,
      digito_agencia: form.digito_agencia || null,
      numero_conta: form.numero_conta || null,
      digito_conta: form.digito_conta || null,
      tipo_conta: form.tipo_conta,
      nome_agencia: form.nome_agencia || null,
      titular_conta: form.titular_conta || null,
      cpf: cpfLimpo || null,
      finalidade: form.finalidade || null,
      tipo_chave_pix: form.tipo_chave_pix || null,
      chave_pix: form.chave_pix || null,
      tipo_cef: form.tipo_cef ? 'N' : null,
    };
    if (editando) {
      payload.is_edicao = true;
    } else {
      payload.is_edicao = false;
    }
    var fn = editando
      ? atualizarContaBancariaConta(ge, codigo, payload)
      : inserirContaBancariaConta(ge, codigo, payload);
    fn
      .then(function() {
        toast.success('Conta bancária salva!');
        setShowModal(false);
        carregar();
      })
      .catch(function(err) {
        const msg = err && err.message
          ? err.message
          : 'Erro ao salvar conta bancária';
        toast.error(msg);
      })
      .finally(function() { setSalvando(false); });
  };

  var handleExcluir = function() {
    excluirContaBancariaConta(ge, codigo, {
      codigo_banco: showExcluir.codigo_banco,
      agencia: showExcluir.agencia,
      numero_conta: showExcluir.numero_conta,
    })
      .then(function() {
        toast.success('Conta bancária excluída!');
        setShowExcluir(null);
        carregar();
      })
      .catch(function() { toast.error('Erro ao excluir conta bancária'); });
  };

  var handleChange = function(e) {
    var campo = e.target.name;
    var valor = e.target.value;
    setForm(function(f) { return { ...f, [campo]: valor }; });
  };

  var handleChangeCpf = function(e) {
    var mascarado = aplicarMascara(e.target.value, 'cpf');
    setForm(function(f) { return { ...f, cpf: mascarado }; });
  };

  return (
    <div className="contas-tab-content">
      <div className="d-flex justify-content-end mb-2">
        <Button size="sm" variant="primary" onClick={handleNovo}>+ Incluir</Button>
      </div>
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <Table size="sm" bordered className="contas-sub-grid">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Banco</th>
              <th>Agência</th>
              <th>D.Ag</th>
              <th>Conta</th>
              <th>D.Conta</th>
              <th>Operação</th>
              <th>Titular</th>
              <th>PIX</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lista.length === 0 ? (
              <tr><td colSpan={10} className="text-center text-muted">Nenhuma conta bancária</td></tr>
            ) : (
              lista.map(function(item, i) {
                var opItem = OPERACAO_OPTS.find(function(o) { return o.value === item.tipo_conta; });
                return (
                  <tr key={item.codigo_banco + '_' + item.agencia + '_' + item.numero_conta + '_' + i}>
                    <td>{item.tipo !== null && item.tipo !== undefined ? item.tipo : '-'}</td>
                    <td>{item.nome_banco !== null && item.nome_banco !== undefined ? item.nome_banco : item.codigo_banco}</td>
                    <td>{item.agencia}</td>
                    <td>{item.digito_agencia !== null && item.digito_agencia !== undefined ? item.digito_agencia : '-'}</td>
                    <td>{item.numero_conta}</td>
                    <td>{item.digito_conta !== null && item.digito_conta !== undefined ? item.digito_conta : '-'}</td>
                    <td>{opItem ? opItem.label : '-'}</td>
                    <td>{item.titular_conta !== null && item.titular_conta !== undefined ? item.titular_conta : '-'}</td>
                    <td>{item.tipo_chave_pix ? 'Sim' : '-'}</td>
                    <td>
                      <Button size="sm" variant="outline-primary" className="mr-1" onClick={function() { handleEditar(item); }}>Editar</Button>
                      <Button size="sm" variant="outline-danger" onClick={function() { setShowExcluir(item); }}>Excluir</Button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      )}

      <Modal show={showModal} onHide={function() { setShowModal(false); }} size="xl">
        <Modal.Header closeButton className="contas-modal-header">
          <Modal.Title>{editando ? 'Editar Conta Bancária' : 'Incluir Conta Bancária'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Tipo</Form.Label>
                <Form.Control type="text" size="sm" name="tipo" value={form.tipo} onChange={handleChange} maxLength={3} />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small">Banco</Form.Label>
                <Select
                  placeholder="Selecione o banco..."
                  options={bancosLista}
                  value={bancosLista.find(function(b) { return String(b.value) === String(form.codigo_banco); }) || null}
                  onChange={function(opt) { setForm(function(f) { return { ...f, codigo_banco: opt ? opt.value : '', nome_banco: opt ? opt.label.split(' - ').slice(1).join(' - ') : '' }; }); }}
                  isClearable
                  noOptionsMessage={function() { return 'Nenhum banco'; }}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Agência</Form.Label>
                <Form.Control type="text" size="sm" name="agencia" value={form.agencia} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={1}>
              <Form.Group>
                <Form.Label className="small">Dg.Ag</Form.Label>
                <Form.Control type="text" size="sm" name="digito_agencia" value={form.digito_agencia} onChange={handleChange} maxLength={1} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Nome Agência</Form.Label>
                <Form.Control type="text" size="sm" name="nome_agencia" value={form.nome_agencia} onChange={handleChange} maxLength={30} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Nº Conta</Form.Label>
                <Form.Control type="text" size="sm" name="numero_conta" value={form.numero_conta} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={1}>
              <Form.Group>
                <Form.Label className="small">Dg.</Form.Label>
                <Form.Control type="text" size="sm" name="digito_conta" value={form.digito_conta} onChange={handleChange} maxLength={2} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Operação</Form.Label>
                <Select
                  placeholder="Selecione..."
                  options={OPERACAO_OPTS}
                  value={OPERACAO_OPTS.find(function(o) { return o.value === form.tipo_conta; }) || OPERACAO_OPTS[0]}
                  onChange={function(opt) { setForm(function(f) { return { ...f, tipo_conta: opt ? opt.value : null }; }); }}
                  isClearable
                  noOptionsMessage={function() { return 'Nenhuma operação'; }}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Finalidade</Form.Label>
                <Form.Control type="text" size="sm" name="finalidade" value={form.finalidade} onChange={handleChange} maxLength={2} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">CPF/CNPJ</Form.Label>
                <Form.Control
                  type="text"
                  size="sm"
                  name="cpf"
                  value={aplicarMascara(form.cpf, 'cpf')}
                  onChange={handleChangeCpf}
                  maxLength={18}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <Form.Group>
                <Form.Label className="small">Nome Titular</Form.Label>
                <Form.Control type="text" size="sm" name="titular_conta" value={form.titular_conta} onChange={handleChange} maxLength={30} />
              </Form.Group>
            </Col>
            <Col md={3} className="d-flex align-items-end pb-2">
              <Form.Check
                type="checkbox"
                id="tipo-cef-check"
                label="NSGED"
                checked={!!form.tipo_cef}
                onChange={function(e) {
                  var marcado = e.target.checked;
                  setForm(function(f) { return { ...f, tipo_cef: marcado }; });
                }}
              />
            </Col>
          </Row>

          <p className="small font-weight-bold mt-3 mb-1">Chave PIX</p>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Tipo da Chave</Form.Label>
                <Select
                  options={TIPO_CHAVE_PIX_OPTS}
                  value={TIPO_CHAVE_PIX_OPTS.find(function(t) { return t.value === form.tipo_chave_pix; }) || TIPO_CHAVE_PIX_OPTS[0]}
                  onChange={function(opt) { setForm(function(f) { return { ...f, tipo_chave_pix: opt ? opt.value : '' }; }); }}
                />
              </Form.Group>
            </Col>
            <Col md={5}>
              <Form.Group>
                <Form.Label className="small">Chave PIX</Form.Label>
                <Form.Control type="text" size="sm" name="chave_pix" value={form.chave_pix} onChange={handleChange} maxLength={350}
                  disabled={!form.tipo_chave_pix}
                  placeholder={form.tipo_chave_pix ? '' : 'Selecione o tipo da chave'}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowModal(false); }}>Cancelar</Button>
          <Button variant="success" onClick={handleSalvar} disabled={salvando}>
            {salvando ? <Spinner animation="border" size="sm" /> : 'Gravar'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={!!showExcluir} onHide={function() { setShowExcluir(null); }}>
        <Modal.Header closeButton className="contas-modal-header"><Modal.Title>Confirmar Exclusão</Modal.Title></Modal.Header>
        <Modal.Body>Deseja excluir a conta bancária selecionada?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowExcluir(null); }}>Não</Button>
          <Button variant="danger" onClick={handleExcluir}>Excluir</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabContasBancarias;
